<template>
  <div>
    <h1 class="pa-3">
      MERCHANT EDIT STORE APPROVE
      <v-btn icon @click="initial()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </h1>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="is_loading_store"
      :items="edit_store_approve_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <!-- <td class="text-xs-center">{{ props.item.store_code }}</td> -->
        <td class="text-xs-center">{{ props.item.store_name_th }}</td>
        <td class="text-xs-center">{{ props.item.store_name_en }}</td>
        <td class="text-xs-center">{{ props.item.user_tel }}</td>
        <td class="text-xs-center">
          {{
            moment(props.item.store_update_at).format("MMMM Do YYYY, HH:mm:ss")
          }}
        </td>
        <td class="text-xs-center">
          <button
            v-if="!isEditStoreApprove"
            class="view-detail-btn"
            @click="toDetailStore(props.item)"
          >
            <span>See Detail</span>
          </button>
        </td>
      </template>

      <template slot="no-data">
        <div
          v-if="
            edit_store_approve_list.length == 0 && is_loading_store != 'black'
          "
        >
          No data available
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{
            is_loading_store == "black" ? "Loading data ..." : is_loading_store
          }}
        </div>
      </template>
    </v-data-table>
    <editStoreDetailDialog
      @close="
        detail_dialog = false;
        resetSelectedItem();
      "
      :selected_item="selected_item"
      :dialog="detail_dialog"
      @setDialog="detail_dialog = $event"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import editStoreDetailDialog from "./EditStoreDetailDialog.vue";
export default {
  data: () => ({
    search: "",
    detail_dialog: false,
    selected_item: {},
    testData: "",
    is_loading_store: false,
    disable_popular: false,
    store_name_th: null,
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      // {
      //   text: "Code",
      //   align: "center",
      //   sortable: false,
      // },
      {
        text: "Store Name TH",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "Store Name EN",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "OWNER Tel.",
        align: "center",
        value: "store_address_th",
        sortable: false,
      },
      {
        text: "Request Date/Time",
        align: "center",
        value: "store_address_en",
        sortable: false,
      },
      {
        text: "",
        align: "center",
        sortable: false,
      },
    ],
  }),
  components: {
    editStoreDetailDialog,
  },
  computed: {
    ...mapState({
      edit_store_approve_list: (state) =>
        state.fetchStoreApproveBack.edit_store_approve_list,
    }),
    ...mapGetters(["isEditStoreApprove"]),
    pages() {
      if (this.length != 0) {
        this.pagination.totalItems = this.edit_store_approve_list.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    store_list: {
      handler: function () {
        let count = 0;
        for (let val of this.store_list) {
          if (val.store_popular == true) {
            count++;
          }
        }
        if (count >= 5) {
          this.disable_popular = true;
        } else {
          this.disable_popular = false;
        }
      },
      deep: true,
    },
  },

  created() {
    this.resetSelectedItem();
    this.fetchData();
  },
  methods: {
    moment,
    initial() {
      this.resetSelectedItem();
      this.fetchData();
    },
    resetSelectedItem() {
      this.selected_item = {
        store_info: {
          store_edit_store_id: null,
          store_edit_store_name_th: "",
          store_edit_store_name_en: "",
          store_edit_store_name_cn: "",
          store_edit_store_description_th: "",
          store_edit_store_description_en: "",
          store_edit_store_description_cn: null,
          store_edit_store_tel: [{ tel: "" }],
          store_edit_store_type: [],
          store_edit_store_email: "",
          store_edit_store_address_th: "",
          store_edit_store_address_en: "",
          store_edit_store_address_cn: null,
          store_edit_store_district: null,
          store_edit_store_sub_district: null,
          store_edit_store_province: null,
          store_edit_store_zipcode: null,
          store_edit_store_note: null,
          store_edit_store_price_range_start: 0,
          store_edit_store_price_range_end: 0,
          store_edit_store_lat: "",
          store_edit_store_long: "",
          store_province: "",
        },
        store_latlng: {},
      };
    },
    toDetailStore(item) {
      this.selected_item = item;
      this.detail_dialog = true;
    },
    async fetchData() {
      this.is_loading_store = true;
      await this.$store.dispatch("fetchStoreApproveBack/getEditStoreApprove");
      this.is_loading_store = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}
.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>


